module.exports = __webpack_public_path__ + "img/wyeth-print-gallery.ad75620d.jpg";